import type { ApiClient } from '@prismo-io/schemas';

export const fetchFormationLevels = async (
  client: ApiClient,
  term: string | null
) => {
  const baseQuery = client
    .from('quark_formation_levels')
    .select('id, name')
    .order('name');

  if (!term) {
    const { data } = await baseQuery;

    return data || [];
  }

  const { data } = await baseQuery.ilike('name', `%${term}%`);

  return data || [];
};
